import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideCreateSkillGroupModal } from '../../actions'
import _ from 'lodash';

import { CreateSkillGroupModal } from './CreateSkillGroupModal';
import { updateCreateSkillGroupFormValues, clearCreateSkillGroupModalValues, createSkillGroup } from '../../actions/createSkillGroup';

class CreateSkillModalGroupController extends Component {
    constructor(props) {
        super(props);

        this.formUpdated = this.formUpdated.bind(this);
        this.formSubmitted = this.formSubmitted.bind(this);
    }

    formSubmitted(event) {
        const {createSkillGroup, data} = this.props;
        event.preventDefault();
        if( !data.isRequesting )
        {
            createSkillGroup(data);
        }
    }

    formUpdated(event) {
        const {updateCreateSkillGroupFormValues, data} = this.props;
        const {target} = event;
        
        // Note this assumes that each field in the modal is named the same as the validation boolean
        // in the reducer's data, but in a readable fashion:
        // e.g.: Activity Name => activityName => activityNameValid
        // Where the first name is the name of the field in the modal, the second is the key generated from that name,
        // and the third is the name of validation boolean that we will update.
        const key = _.camelCase(target.name);
        let value = target.value;

       

        updateCreateSkillGroupFormValues({
            ...data,
            [key]: value,
            [`${key}Valid`]: isValid(key, target.value)
        });
    }


    render() {
        const {show, hideCreateSkillGroupModal, data, clearCreateSkillGroupModalValues} = this.props;    
        return (
            <CreateSkillGroupModal
                show={show}
                hide={() => {
                    clearCreateSkillGroupModalValues();
                    hideCreateSkillGroupModal();
                }}
                data={{
                    skillGroupNameValidation:            validationState(data.skillGroupNameValid),
                    formValid:                      formValid(data),
                    isRequesting:                   data.isRequesting
                }}
                updated={this.formUpdated}
                submitted={this.formSubmitted}
                />
        );
    }
}

const isValid = (name, value) => {
    switch(name) {
        case 'skillGroupName':      return !!value;     
        default:                    return false;
    }
};

const validationState = isValid => {
    return isValid ? 'success' : 'error';
};

const formValid = data => {
    return data.skillGroupNameValid
};

CreateSkillModalGroupController.propTypes = {
    show:                                PropTypes.bool.isRequired,
    hideCreateSkillGroupModal:           PropTypes.func.isRequired,
    data:                                PropTypes.object.isRequired,
    updateCreateSkillGroupFormValues:    PropTypes.func.isRequired,
    clearCreateSkillGroupModalValues:    PropTypes.func.isRequired,
    createSkillGroup:                    PropTypes.func.isRequired
};

const mapDispatchToProps = {
    hideCreateSkillGroupModal,
    clearCreateSkillGroupModalValues,
    updateCreateSkillGroupFormValues,
    createSkillGroup
};

const mapStateToProps = state => ({
    data: state.ui.createSkillGroupData,
    show: state.ui.createSkillGroup.show
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateSkillModalGroupController);



// WEBPACK FOOTER //
// ./src/components/createSkillGroupModal/CreateSkillGroupModalController.js